/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { hot } from 'react-hot-loader';
import { BREAKPOINT_MD } from 'store/constants';

const Container = styled.div(
  props => `
  display: grid;
  grid-template-rows: 50px 1fr;
  grid-template-columns: 100%;
  grid-column-end: span ${props.col || 2};
  grid-row-end: span ${props.row || 2};

  font-size: 1rem;
  background-color: var(--brand-white);
  border-radius: 0px;
  border-bottom: solid 1px var(--brand-black);

  position: relative;

  @media (max-width: ${BREAKPOINT_MD.toString()}) {
    width: 100vw;
  }

  ${props.styles || ''}
`
);

type Props = {
  row?: number,
  col?: number,
  styles?: string,
  children: React$Node,
};

const Component = (props: Props) => {
  return (
    <Container {...props} className="Cell">
      {props.children}
    </Container>
  );
};

export default hot(module)(Component);
